import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getFAIcon, toTemplateResult } from 'enchoice-fabric-react-lib';
import { ActionButton, IconButton } from 'office-ui-fabric-react/lib/Button';
import { ContextualMenuItemType } from 'office-ui-fabric-react/lib/ContextualMenu';
import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import { Persona, PersonaInitialsColor, PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { createTheme, getTheme } from 'office-ui-fabric-react/lib/Styling';
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReactSVG from 'react-svg';
import { Dispatch } from 'redux';
import Api from '../../../../components/Api';
import { LoginMode, SecurityActionTypes } from '../../../../redux/Actions/Security/ActionTypes';
import { IRootState } from '../../../../redux/Reducers/RootReducer';
// import HeaderSearchBox from './HeaderSearchBox/HeaderSearchBox';
import './Header.css';

const numberOfQuickButtons = 2;

const headerTheme = createTheme({
  palette: {
    neutralPrimary: '#fff'
  }
});

const embeddedStyle: React.CSSProperties = {
  height: '70px',
  backgroundRepeat: 'repeat-x',
  backgroundColor: 'unset !important',
  padding: 0
};

const normalStyle: React.CSSProperties = {
  height: '70px',
  backgroundRepeat: 'repeat-x',
  backgroundImage: 'linear-gradient(#666565, #454343 50%, #242121)',
  padding: '8px 0 0 0',
  color: '#fff',
  fontSize: '22px',
  fontWeight: 400,
  lineHeight: '50px'
};

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    logout: () => dispatch({ type: SecurityActionTypes.LOGOUT_USER })
  };
}

function mapStateToProps(state: IRootState, ownProps: any) {
  return { username: state.securityState.security.username, loginMode: state.securityState.security.loginMode };
}

export interface IQuickButtonInfo {
  id: number;
  name: string;
  template: number;
  icon: string;
}

export interface IHeaderState {
  isCalloutVisible: boolean;
  isSearchCalloutVisible: boolean;
  recentSearches: any[];
  quickButtons: IQuickButtonInfo[];
}

class Header extends React.PureComponent<any, IHeaderState> {
  /* private menuButtonElement = createRef<HTMLElement>(); */

  constructor(props: any) {
    super(props);
    this.state = {
      isCalloutVisible: false,
      isSearchCalloutVisible: false,
      recentSearches: [],
      quickButtons: []
    };

    this.getLogo = this.getLogo.bind(this);
    this.getPersona = this.getPersona.bind(this);
    this.getQuickButtons = this.getQuickButtons.bind(this);

    this.goToHome = this.goToHome.bind(this);
    this.goToSettings = this.goToSettings.bind(this);
    this.goToTemplates = this.goToTemplates.bind(this);
    this.goToMenus = this.goToMenus.bind(this);
    this.goToShortcut = this.goToShortcut.bind(this);
    this.goToQuickButton = this.goToQuickButton.bind(this);
    this.goToDrawerGroups = this.goToDrawerGroups.bind(this);

    this.logout = this.logout.bind(this);
  }

  public componentDidMount() {
    Api.get(`quickbuttons?_limit=${numberOfQuickButtons}`)
      .then(response => {
        this.setState({ quickButtons: response.data.data });
      })
      .catch(error => {
        console.log('Error:', error);
      });
  }

  public render(): JSX.Element {
    const isEmbeddedLogin = !!(this.props.loginMode && this.props.loginMode === LoginMode.EMBEDDED);

    return (
      <Fabric className="ms-Grid headerBar" dir="ltr" style={isEmbeddedLogin ? embeddedStyle : normalStyle}>
        <div className="ms-Grid-row " style={{ padding: '0', margin: 0 }}>
          <div className="ms-Grid-col ms-sm3 ms-md3 ms-lg3" style={{ padding: '0' }}>
            <div className="headerIcon" /*  ref={this.menuButtonElement} */>
              {this.getLogo(isEmbeddedLogin)}
              {/*               <DefaultButton
                primary={true}
                disabled={false}
                checked={false}
                iconProps={{
                  iconName: 'Waffle',
                  style: {
                    color: 'white',
                    fontSize: '40px'
                  }
                }}
                onClick={this.onShowMenuClicked}
                style={{ height: '50px', width: '50px', minWidth: '50px' }}
              /> */}
            </div>

            {/* <Callout
              ariaLabelledBy={'callout-label-1'}
              ariaDescribedBy={'callout-description-1'}
              role={'alertdialog'}
              gapSpace={1}
              isBeakVisible={true}
              beakWidth={10}
              onDismiss={this.onCalloutDismiss}
              setInitialFocus={true}
              hidden={!this.state.isCalloutVisible}
              target={this.menuButtonElement.value}
            >
              <div className="ms-Grid">
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm ms-md ms-lg calloutDiv calloutDivBlue" onClick={this.onCalloutDismiss}>
                    <i className="ms-Icon ms-Icon--FolderList calloutIcon" aria-hidden="true" />
                    <br />
                    <span className="calloutText">KTX</span>
                  </div>
                  <div className="ms-Grid-col ms-sm ms-md ms-lg calloutDiv calloutDivPurle" onClick={this.onCalloutDismiss}>
                    <i className="ms-Icon ms-Icon--Money calloutIcon" aria-hidden="true" />
                    <br />
                    <span className="calloutText">Kwiwk Expense</span>
                  </div>
                  <div className="ms-Grid-col ms-sm ms-md ms-lg calloutDiv calloutDivOrange" onClick={this.onCalloutDismiss}>
                    <i className="ms-Icon ms-Icon--Suitcase calloutIcon" aria-hidden="true" />
                    <br />
                    <span className="calloutText">Case Manager</span>
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm ms-md ms-lg calloutDiv calloutDivDeepBlue" onClick={this.onCalloutDismiss}>
                    <i className="ms-Icon ms-Icon--Chart calloutIcon" aria-hidden="true" />
                    <br />
                    <span className="calloutText">Reports</span>
                  </div>
                  <div className="ms-Grid-col ms-sm ms-md ms-lg calloutDiv calloutDivGreen" onClick={this.onCalloutDismiss}>
                    <i className="ms-Icon ms-Icon--GroupObject calloutIcon" aria-hidden="true" />
                    <br />
                    <span className="calloutText">Module Manager</span>
                  </div>
                  <div className="ms-Grid-col ms-sm ms-md ms-lg calloutDiv calloutDivFadedRed" onClick={this.onCalloutDismiss}>
                    <i className="ms-Icon ms-Icon--People calloutIcon" aria-hidden="true" />
                    <br />
                    <span className="calloutText">User Manager</span>
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm ms-md ms-lg calloutDiv calloutDivLightBlue" onClick={this.onCalloutDismiss}>
                    <i className="ms-Icon ms-Icon--Settings calloutIcon" aria-hidden="true" />
                    <br />
                    <span className="calloutText">Settings</span>
                  </div>
                  <div className="ms-Grid-col ms-sm ms-md ms-lg calloutDiv calloutDivRed" onClick={this.onCalloutDismiss}>
                    <i className="ms-Icon ms-Icon--Admin calloutIcon" aria-hidden="true" />
                    <br />
                    <span className="calloutText">KwikTag Admin</span>
                  </div>
                  <div className="ms-Grid-col ms-sm ms-md ms-lg calloutDiv calloutDivLightGreen" onClick={this.onCalloutDismiss}>
                    <i className="ms-Icon ms-Icon--Boards calloutIcon" aria-hidden="true" />
                    <br />
                    <span className="calloutText">Logs</span>
                  </div>
                </div>
              </div>
            </Callout> */}
          </div>
          <div className="ms-Grid-col ms-sm6" style={{ paddingTop: '10px' }}>
            {/*<HeaderSearchBox />*/}
          </div>
          <div className="ms-Grid-col ms-sm3" style={{ paddingTop: '10px' }}>
            {this.getPersona(isEmbeddedLogin)}
            {this.getQuickButtons()}
          </div>
        </div>
      </Fabric>
    );
  }

  private getLogo(isEmbeddedLogin: boolean): JSX.Element {
    if (isEmbeddedLogin) {
      return <></>;
    }
    return (
      <ActionButton
        className="headerText"
        allowDisabledFocus={true}
        onClick={this.goToHome}
        styles={{ root: { color: getTheme().palette.themePrimary, verticalAlign: 'middle' } }}
      >
        <ReactSVG
          src={process.env.PUBLIC_URL + '/KTX_Logo_4.svg'}
          //evalScripts="always"
          // tslint:disable-next-line:jsx-no-lambda
          fallback={() => <span>KTX</span>}
          // tslint:disable-next-line:jsx-no-lambda
          loading={() => <span>KTX</span>}
          // tslint:disable-next-line:jsx-no-lambda
          afterInjection={(error, svg) => {
            if (error) {
              console.error(error);
              return;
            }
          }}
          beforeInjection={svg => {
            svg.classList.add('ktxHeaderLogo');
          }}
          renumerateIRIElements={false}
          wrapper="span"
          className="wrapper-class-name"
        />
      </ActionButton>
    );
  }

  private getPersona(isEmbeddedLogin: boolean): JSX.Element {
    const { t } = this.props;

    const menuItems = [
      /*
      {
        iconProps: {
          iconName: 'PlayerSettings'
        },
        key: 'settings',
        onClick: this.goToSettings,
        text: t('header.menu.settings')
      },*/
      {
        iconProps: {
          iconName: 'SearchAndApps'
        },
        key: 'templates',
        onClick: this.goToTemplates,
        text: t('header.menu.templates')
      },
      {
        iconProps: {
          iconName: 'FabricFolder'
        },
        key: 'drawergroups',
        onClick: this.goToDrawerGroups,
        text: t('header.menu.drawergroups')
      }
      /*,
      {
        iconProps: {
          iconName: 'CollapseMenu'
        },
        key: 'menus',
        onClick: this.goToMenus,
        text: t('header.menu.menus')
      },
      {
        iconProps: {
          iconName: 'PowerButton'
        },
        key: 'quickbutton',
        onClick: this.goToQuickButton,
        text: t('header.menu.quickbuttons')
      }*/
    ];

    const extraMenuItems = [
      {
        key: 'divider_1',
        itemType: ContextualMenuItemType.Divider
      },
      {
        key: 'logout',
        text: t('header.menu.logout'),
        iconProps: {
          iconName: 'SignOut'
        },
        onClick: this.logout,
        target: '_blank'
      }
    ];

    return (
      <ActionButton
        className="pullRight persona"
        allowDisabledFocus={true}
        disabled={false}
        checked={true}
        menuProps={{
          items: isEmbeddedLogin ? menuItems : [...menuItems, ...extraMenuItems],
          shouldFocusOnMount: true
        }}
        styles={{ root: { marginTop: '-5px' } }}
      >
        {!isEmbeddedLogin ? (
          <Persona
            size={PersonaSize.size24}
            initialsColor={PersonaInitialsColor.purple}
            text={this.props.username}
            className="pullRight persona"
            theme={headerTheme}
          />
        ) : (
          <></>
        )}
      </ActionButton>
    );
  }

  private getQuickButtons(): JSX.Element[] {
    const { quickButtons } = this.state;

    return quickButtons.map(btn => {
      return (
        <IconButton
          key={btn.id}
          className="quickbutton"
          allowDisabledFocus={true}
          disabled={false}
          checked={false}
          title={btn.name}
          ariaLabel={btn.name}
          // tslint:disable-next-line:jsx-no-lambda
          onClick={() => this.goToShortcut(btn.template)}
          styles={{ root: { color: getTheme().palette.themePrimary, fontSize: '20px' } }}
        >
          <FontAwesomeIcon icon={getFAIcon(btn.icon)} />
        </IconButton>
      );
    });
  }

  private goToHome(): void {
    this.props.history.push('/search');
  }

  private goToSettings(): void {
    this.props.history.push('/search/settings');
  }
  private goToTemplates(): void {
    this.props.history.push('/search/template');
  }

  private goToDrawerGroups(): void {
    this.props.history.push('/search/drawergroups');
  }

  private goToMenus(): void {
    this.props.history.push('/search/menu');
  }

  private goToQuickButton(): void {
    this.props.history.push('/search/quickbutton');
  }

  private logout(): void {
    this.props.logout();
  }

  private goToShortcut(template: number | string): void {
    Api.get(`templates/${template}`)
      .then(response => {
        const encoded = toTemplateResult(response.data);
        this.props.history.push(`/search/template/${template}/results?properties=${encoded}`);
      })
      .catch(error => {
        console.log('Error:', error);
        console.log('Error Response:', 'Request failed with status code ' + error.response.status, error.response);
      });
  }

  /*   private onShowMenuClicked = (): void => {
    this.setState({
      isCalloutVisible: !this.state.isCalloutVisible
    });
  };

  private onCalloutDismiss = (): void => {
    this.setState({
      isCalloutVisible: false
    });
  }; */
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Header)) as any);
